import { FlyoutMenu, FlyoutMenuActionItem } from "./FlyoutMenu/FlyoutMenu"
import { Bug, Lightbulb, Mail, MessageBubbleQuick } from "@nova/component-icons"
import { download } from "tools/browser/download"
import { summarize } from "@nova/use-debug"
import { memo } from "react"

const HelpAndResources = memo(
    ({
        onBlur,
        title = "Help & Resources",
        className = "w-full bottom-9",
    }: {
        onBlur: () => void
        title?: string
        className?: string
    }) => {
        const actionSections: FlyoutMenuActionItem[][] = [
            [
                {
                    title: "Learn Center",
                    icon: Lightbulb,
                    shouldShowExitIcon: true,
                    onClick: () => window.open("https://learn.mapnova.com", "_blank"),
                },
                {
                    title: "Contact Us",
                    icon: Mail,
                    shouldShowExitIcon: true,
                    onClick: () => window.open("mailto:help@mapnova.com", "_blank"),
                },
                {
                    title: "Give Feedback",
                    icon: MessageBubbleQuick,
                    shouldShowExitIcon: true,
                    onClick: () => window.open("mailto:info@mapnova.com", "_blank"),
                },
                {
                    title: "Download Debug",
                    icon: Bug,
                    onClick: () => download("debug.txt", "text/plain;charset=utf-8", summarize()),
                },
            ],
        ]

        return (
            <FlyoutMenu
                title={title}
                className={className}
                actionSections={actionSections}
                onBlur={onBlur}
            />
        )
    }
)
HelpAndResources.displayName = "HelpAndResources"
export { HelpAndResources }
